export default [
  {
    path: '/welcome-portal',
    name: 'welcomePortal',
    component: () => import('@/views/welcome/Layout'),
    meta: {
      isWelcomePortal: true,
    },
    children: [
      {
        path: '/',
        name: 'main',
        component: () => import('@/views/welcome/Master'),
      },
    ],
  },
];
